import { render, staticRenderFns } from "./Shipinsdk.vue?vue&type=template&id=01cc7253"
import script from "./Shipinsdk.vue?vue&type=script&lang=js"
export * from "./Shipinsdk.vue?vue&type=script&lang=js"
import style0 from "./Shipinsdk.vue?vue&type=style&index=0&id=01cc7253&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports